/**
 * What a failed § 312k cancellation declaration tells the reader (kitecorp/transferify-ui#2327).
 * React-free, like every other rule in this feature.
 *
 * <p>Two answers only, and the shortness is the decision. A transport failure gets its own sentence because
 * the reader can act on it — check the connection, try again. Everything else is generic, INCLUDING the 429:
 * telling an anonymous caller that cancellations are rate limited invites them to probe the limit, and the
 * remedy the reader has is identical either way.
 *
 * <p>A 400 is also generic, and that is not laziness. The form validates the same rules the api does before
 * it posts, so a 400 here means the two have drifted — a defect for us to fix, not a sentence for the reader
 * to act on. It must never read as "you typed something wrong", because they did not.
 */

/** A key of the catalogue's `cancellation.errors` namespace. */
export type CancellationFailureKey = "network" | "generic";

/** The axios-shaped fields this rule reads, so the rule needs no axios import and no React. */
interface FailureLike {
	isAxiosError?: boolean;
	response?: {status?: number} | undefined;
}

export function cancellationFailureKey(failure: unknown): CancellationFailureKey {
	const candidate = failure as FailureLike | null | undefined;
	// An axios error with NO response never reached the server: DNS, offline, a refused connection, a
	// timeout. That is the one case where "check your connection" is true advice rather than a guess.
	return candidate?.isAxiosError === true && candidate.response === undefined ? "network" : "generic";
}
